module.exports = __webpack_public_path__ + "img/banner.4d5039ae.png";